import { formatMoney } from '../utils/money';


const logClerkClick = (clerkKey, productId, api, labels) => {
  const visitorId = window.sessionStorage.getItem('visitor_id');
  if (!visitorId) return;

  const params = new URLSearchParams({
    key: clerkKey,
    labels: JSON.stringify(labels),
    api: api,
    visitor: visitorId,
    product: parseInt(productId, 10),
  });

  fetch(`https://api.clerk.io/v2/log/click?${params.toString()}`, {
    method: 'GET',
    keepalive: true,
    mode: 'no-cors',
  });
};

export const fetchProductsFromClerk = (cartItems, clerkRecommendationsUrl, clerkKey, clerkUpsellLimit, openUpsellDrawer = false, moneyFormat, selectSize, addToCartText, mainCartTitle = null, containerDesktop, containerMobile, clerkApiLabel = undefined, loadingText = undefined) => {
    const products = [];

    cartItems.forEach((item) => {
      products.push(item.dataset.cartItemProductId);
    });

    if (products.length > 0) {
      if (mainCartTitle) mainCartTitle.classList.add('hidden');
      const apiLabel = clerkApiLabel ?? (openUpsellDrawer ? '["Upsell - Cart drawer"]' : '["Upsell - Main cart"]');
      const visitorId = window.sessionStorage.getItem('visitor_id');
      const params = new URLSearchParams({
        key: clerkKey,
        products: `[${products.join(',')}]`,
        limit: clerkUpsellLimit,
        labels: apiLabel,
        attributes: '["handle","name","list_price","price","image","url","on_sale","variants","status","id"]',
        filter: 'stock > 0',
        ...(visitorId && { visitor: visitorId }),
      });

      fetch(`${clerkRecommendationsUrl}?${params.toString()}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'ok' && data.result && data.result.length > 0) {
            const api = new URL(clerkRecommendationsUrl).pathname.replace('/v2/', '');
            const labelsArray = JSON.parse(apiLabel);
            renderSellProductsDrawer(data.product_data, moneyFormat, selectSize, addToCartText, mainCartTitle, containerDesktop, containerMobile, clerkKey, api, labelsArray, loadingText);
          }
          if (openUpsellDrawer) {
            document.dispatchEvent(new CustomEvent('cart-drawer:open-upsell-drawer', { detail: { open: true } }));
          }
        })
        .catch(() => {
          if (openUpsellDrawer) {
            document.dispatchEvent(new CustomEvent('cart-drawer:open-upsell-drawer', { detail: { open: true } }));
          }
        })
        .finally(() => {
          if (mainCartTitle) mainCartTitle.classList.remove('hidden');
        });
    } else if (mainCartTitle) {
      mainCartTitle.classList.remove('hidden');
    }
  };

const resolveVariantId = (variants) => {
  if (Array.isArray(variants)) {
    const first = variants[0];
    if (first && typeof first === 'object') return first.id;
    return first;
  }
  if (variants && typeof variants === 'object') return variants.id;
  return variants;
};

const populateNode = (node, p, moneyFormat) => {
  const quantityContainer = node.querySelector('[data-quantity-container]');
  if (quantityContainer) quantityContainer.classList.add('hidden');

  const title = node.querySelector('[data-tpl="title"]');
  if (title) title.textContent = p.name;

  const price = node.querySelector('[data-tpl="price"]');
  if (price) price.textContent = formatMoney(p.price * 100, moneyFormat);

  const compareAtPrice = node.querySelector('[data-tpl="compareAtPrice"]');
  if (compareAtPrice) compareAtPrice.textContent = formatMoney(p.list_price * 100, moneyFormat);

  if (p.on_sale === true && compareAtPrice) {
    compareAtPrice.classList.remove('hidden');
  }

  const img = node.querySelector('[data-tpl="image"]');
  if (img) {
    img.src = p.image;
    img.srcset = p.image;
    img.alt = p.name || '';
  }

  const imgLink = node.querySelector('[data-tpl="imageLink"]');
  if (imgLink) imgLink.href = p.url;
};

const createSelectSizeLink = (p, selectSize) => {
  const link = document.createElement('a');
  link.href = p.url;
  link.textContent = selectSize;
  link.classList.add('upsell-cta');
  link.dataset.clerkProductId = p.id;
  link.dataset.clerkClickTrackingAdded = 'true';
  return link;
};

const createAddToCartWidget = (p, addToCartText, loadingText) => {
  const variantId = resolveVariantId(p.variants);

  const wrapper = document.createElement('div');
  wrapper.dataset.component = 'addToCart';
  wrapper.dataset.variantId = variantId;
  wrapper.dataset.productTitle = p.name;
  wrapper.dataset.productPrice = p.price * 100;
  wrapper.dataset.doNotOpenDrawer = 'true';
  if (loadingText) wrapper.dataset.loadingText = loadingText;

  const btn = document.createElement('button');
  btn.textContent = `+ ${addToCartText}`;
  btn.classList.add('upsell-cta');
  btn.setAttribute('data-button-add-to-cart', '');

  wrapper.appendChild(btn);
  return wrapper;
};

const setCta = (container, p, selectSize, addToCartText, loadingText) => {
  const variantCount = Array.isArray(p.variants) ? p.variants.length : (p.variants ? 1 : 0);

  container.innerHTML = '';
  if (variantCount > 1) {
    container.appendChild(createSelectSizeLink(p, selectSize));
  } else {
    container.appendChild(createAddToCartWidget(p, addToCartText, loadingText));
  }
};

const renderSellProductsDrawer = (products, moneyFormat, selectSize, addToCartText, mainCartTitle, containerDesktop, containerMobile, clerkKey, api, labels, loadingText) => {
    const sellProductsContainer = document.querySelector(containerDesktop);
    const sellProductsContainerMobile = document.querySelectorAll(containerMobile);
    const template = document.querySelector("#sell-product-template");
    const templateMobile = document.querySelector("#sell-product-template-mobile");

    sellProductsContainer.replaceChildren();
    sellProductsContainerMobile.forEach((container) => container.replaceChildren());

  const frag = document.createDocumentFragment();
  const fragMobile = document.createDocumentFragment();

  for (const p of products) {
    const nodeTemplate = template.content.firstElementChild.cloneNode(true);
    const nodeTemplateMobile = templateMobile.content.firstElementChild.cloneNode(true);

    nodeTemplate.dataset.clerkProductId = p.id;
    nodeTemplateMobile.dataset.clerkProductId = p.id;

    populateNode(nodeTemplate, p, moneyFormat);
    populateNode(nodeTemplateMobile, p, moneyFormat);

    setCta(nodeTemplate.querySelector('[data-tpl="addToCart"]'), p, selectSize, addToCartText, loadingText);
    setCta(nodeTemplateMobile.querySelector('[data-tpl="addToCart"]'), p, selectSize, addToCartText, loadingText);

    nodeTemplate.addEventListener('click', () => {
      logClerkClick(clerkKey, p.id, api, labels);
    });
    nodeTemplateMobile.addEventListener('click', () => {
      logClerkClick(clerkKey, p.id, api, labels);
    });

    frag.appendChild(nodeTemplate);
    fragMobile.appendChild(nodeTemplateMobile);
  }

  sellProductsContainer.appendChild(frag);
  sellProductsContainerMobile.forEach((container) => container.appendChild(fragMobile));

  if (mainCartTitle) mainCartTitle.classList.remove('hidden');

  // reattach addtocart component
  document.dispatchEvent(new CustomEvent('shopify:section:load:addToCart', { detail: { container: sellProductsContainer } }));
  sellProductsContainerMobile.forEach((container) => document.dispatchEvent(new CustomEvent('shopify:section:load:addToCart', { detail: { container: container } })));
  const sellProductsContainerMobileEmbla = document.querySelectorAll('[data-drawer-sell-products-mobile-embla]');
  sellProductsContainerMobileEmbla.forEach((container) => document.dispatchEvent(new CustomEvent('shopify:section:load:emblaSlider', { detail: { container: container } })));
}
